// Leaflet
import L from 'leaflet/dist/leaflet';

// Marker Cluster Plugin und Styles
import {MarkerClusterGroup, MarkerCluster} from "leaflet.markercluster/dist/leaflet.markercluster-src.js";

L.Icon.Default.imagePath = '/assets/leaflet/';
L.MarkerClusterGroup = MarkerClusterGroup;
L.MarkerCluster = MarkerCluster;

L.NumberedDivIcon = L.Icon.extend({
    options: {
        number:         '',
        className:      'leaflet-div-icon',
        shadowUrl:      '/assets/leaflet/marker-shadow.png',
        iconSize:       [24, 38],
        iconAnchor:     [12, 37],
        shadowSize:     [39, 39],
        shadowAnchor:   [12, 37],
        popupAnchor:    [0, -33]
    },



    // @method createIcon(oldIcon?: HTMLElement): HTMLElement
    // Called internally when the icon has to be shown, returns a `<img>` HTML element
    // styled according to the options.
    createIcon: function (oldIcon) {
        var div = document.createElement('div');

        var img = this._createImg(this.options['iconUrl']);
        div.appendChild ( img );

        if (this.options['number'] && this.options['number'] !== '' && this.options['number'].toString().match(/^[0-9]/)) {
            var numdiv = document.createElement('div');
            numdiv.setAttribute ( "class", "number" );
            numdiv.innerHTML = this.options['number'] || '';
            div.appendChild ( numdiv );
        }

        this._setIconStyles(div, 'icon');

        return div;
    },
});
